__turbopack_context__.v({
  "badgeSlot": "DprxOG_badgeSlot",
  "card": "DprxOG_card",
  "cardBody": "DprxOG_cardBody",
  "cardTitle": "DprxOG_cardTitle",
  "carousel": "DprxOG_carousel",
  "grid": "DprxOG_grid",
  "heading": "DprxOG_heading",
  "section": "DprxOG_section",
  "shot": "DprxOG_shot",
  "shotWrap": "DprxOG_shotWrap",
  "stepBadge": "DprxOG_stepBadge",
  "subtitle": "DprxOG_subtitle",
  "textStack": "DprxOG_textStack",
});
